import { type ReactNode } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { valorConfig } from '../lib/formato';
import { linkWhatsApp } from '../lib/basePath';
import { useConfiguracaoPublica } from '../lib/hooks';
import { useAuth } from '../../lib/auth';

/**
 * Rodapé — nível 1 (hairline no topo), `nota` `--tinta-3`, empilhado, 40px de
 * respiro acima (DESIGN-FOUNDATION §6.8). Em toda tela do portal.
 *
 * "Falar com a Varga" só é link quando `loja_whatsapp` está configurado de
 * verdade (não é o placeholder do seed) — mesmo padrão do CTA da
 * `LandingConvite`: sem WhatsApp, o `<li>` inteiro some, nunca texto morto sem
 * link (regra do CLAUDE.md contra UI que promete o que não faz).
 *
 * "Sair" é utilitário, não CTA primário (§0) — mesmo estilo dos outros itens
 * do rodapé, só aparece para quem está logado como cliente.
 */
export function Rodape(): ReactNode {
  const { data: config } = useConfiguracaoPublica();
  const wa = linkWhatsApp(config ? valorConfig(config, 'loja_whatsapp') : null);
  const { usuario, sair } = useAuth();
  const navigate = useNavigate();

  const aoSair = async (): Promise<void> => {
    await sair();
    navigate('/', { replace: true });
  };

  return (
    <footer className="mt-10 border-t border-linha pt-5">
      <ul className="flex flex-col gap-2 tipo-nota text-tinta-3">
        <li>
          <Link to="/termos" className="text-acento-texto underline">
            Termos da campanha
          </Link>
        </li>
        <li>Programa válido até 07/07/2027</li>
        {wa && (
          <li>
            <a href={wa} target="_blank" rel="noreferrer" className="text-acento-texto underline">
              Falar com a Varga
            </a>
          </li>
        )}
        {usuario && (
          <li>
            <button
              type="button"
              onClick={() => void aoSair()}
              className="tipo-nota text-tinta-3 underline"
            >
              Sair
            </button>
          </li>
        )}
      </ul>
    </footer>
  );
}
